import React, { useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
  BookOpen, Library, Sparkles, FileText, Scale,
  PenLine, Star, Map, Plus
} from 'lucide-react';
import './OppositionPage.css';

const ACTIONS = [
  {
    key: 'temario',
    label: 'Estudio',
    title: 'Temario',
    desc: 'Consulta los temas, leyes y artículos de la oposición.',
    Icon: BookOpen,
    color: '#6b3fa0',
    bg: '#f3eefb',
    pathFragment: 'temario',
  },
  {
    key: 'examenes-oficiales',
    label: 'Práctica',
    title: 'Exámenes oficiales',
    desc: 'Practica con exámenes de convocatorias pasadas.',
    Icon: Library,
    color: '#2563eb',
    bg: '#eff6ff',
    pathFragment: 'examenes-oficiales',
  },
  {
    key: 'examenes-generados',
    label: 'Práctica · IA',
    title: 'Exámenes generados',
    desc: 'Exámenes creados por IA siguiendo el patrón de los oficiales.',
    Icon: Sparkles,
    color: '#7c3aed',
    bg: '#f5f3ff',
    pathFragment: 'examenes-generados',
  },
  {
    key: 'examen-tema',
    label: 'Práctica',
    title: 'Preguntas por tema',
    desc: 'Practica preguntas de exámenes reales agrupadas por tema.',
    Icon: FileText,
    color: '#0891b2',
    bg: '#ecfeff',
    pathFragment: 'examen-tema',
  },
  {
    key: 'examen-ley',
    label: 'Práctica',
    title: 'Preguntas por ley',
    desc: 'Practica preguntas de exámenes reales agrupadas por ley.',
    Icon: Scale,
    color: '#059669',
    bg: '#ecfdf5',
    pathFragment: 'examen-ley',
  },
  {
    key: 'preguntas-abiertas',
    label: 'Práctica · IA',
    title: 'Preguntas abiertas',
    desc: 'Responde con texto libre; el corrector evalúa los puntos clave.',
    Icon: PenLine,
    color: '#d97706',
    bg: '#fffbeb',
    pathFragment: 'preguntas-abiertas',
  },
  {
    key: 'insights',
    label: 'Análisis',
    title: 'Lo más importante',
    desc: 'Los artículos y conceptos más relevantes del temario.',
    Icon: Star,
    color: '#dc2626',
    bg: '#fef2f2',
    pathFragment: 'insights',
  },
  {
    key: 'grafo',
    label: 'Análisis',
    title: 'Mapa del temario',
    desc: 'Visualización interactiva del grafo de artículos y similitudes.',
    Icon: Map,
    color: '#0369a1',
    bg: '#f0f9ff',
    pathFragment: 'grafo',
  },
];

const CARD_WIDTH = 280;

const OppositionPage = () => {
  const { oppositionName } = useParams();
  const trackRef = useRef(null);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    trackRef.current.scrollBy({ left: dir * (CARD_WIDTH + 16), behavior: 'smooth' });
  };

  return (
    <div>
      <header className="page-header">
        <h1 className="page-title">{oppositionName}</h1>
      </header>

      <div className="carousel-wrapper">
        <div className="carousel-track" ref={trackRef}>
          {ACTIONS.map((a) => (
            <Link
              key={a.key}
              to={`/oposicion/${oppositionName}/${a.pathFragment}`}
              className="action-card"
            >
              <div className="action-top">
                <div className="action-label">{a.label}</div>
                <h3 className="action-title">{a.title}</h3>
                <p className="action-desc">{a.desc}</p>
              </div>
              <div className="action-bottom">
                <div className="action-visual" style={{ background: a.bg, color: a.color }}>
                  <a.Icon size={56} strokeWidth={1.2} />
                </div>
                <div className="action-plus" style={{ color: a.color, borderColor: a.color }}>
                  <Plus size={16} strokeWidth={2} />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="carousel-nav">
          <button className="carousel-btn" onClick={() => scroll(-1)} aria-label="Anterior">‹</button>
          <button className="carousel-btn" onClick={() => scroll(1)} aria-label="Siguiente">›</button>
        </div>
      </div>
    </div>
  );
};

export default OppositionPage;
